<template>
	<div class="brick">
		<div class="list_top_box">
			<div class="left_option">
				<em class="lt_text">Received Date</em>
				<span class="mgr_5"> <CustomDatePicker v-model="fromDate"/> ~ <CustomDatePicker v-model="toDate"/></span>

				<span class="int_type_no_border mgr_5">
					<PartnerSelect v-model="vendorCode" ph="Vendor Code" :showName="false" :vendorOnly="true" @set-partner="setPartner" />
				</span>
			</div>
			<div class="left_option">
				<item-class-select-multi-s ref="ItemClassSelectMultiS" :multiSelect="true" v-model="itemClasses" />
			</div>
			<div class="left_option">
				<a href="javascript:void(0);" class="search_bt" @click="search()">Search</a>
				<a href="javascript:void(0);" class="gray_bt" @click="reset()">Reset</a>
				<span style="display:inline-block;padding-top:5px;padding-left:10px;"> Max 10,000 Records</span>
			</div>
		</div>
		<div>
			<div class="fixed-table-container">
				<div class="table-wrapper" style="height: 95%">
					<table class="list_tbl sticky_list_tbl" v-columns-resizable id="excelTable">
						<colgroup>
							<col style="width: 100px;" />
							<col style="width: 90px;" />
							<col style="width: 90px;" />
							<col style="width: 90px;" />
							<col style="width: 200px;" />
							<col style="width: 120px;" />
							<col />
							<col v-if="user.company_id != 'jc'" style="width: 150px;" />
							<col style="width: 80px;" />
							<col style="width: 80px;" />
							<col style="width: 80px;" />
						</colgroup>

						<thead>
							<tr>
								<th>Received Date</th>
								<th>SH NO</th>
								<th>PO NO</th>
								<th>Vendor Code</th>
								<th>Vendor Name</th>
								<th>{{ headers.class }} Code</th>
								<th>Item</th>
								<th v-if="user.company_id != 'jc'">Color</th>
								<th>Qty</th>
								<th>Price</th>
								<th>Amount</th>
							</tr>
						</thead>
						<tbody>
							<tr v-for="item in root.value" v-bind:key="item.sh_item_no">
								<td class="al_center">{{ item.received_date }}</td>
								<td class="al_center">
									<a href="javascript:void(0)" @click="shipmentGo(item.sh_no)">{{ item.sh_dn }} </a>
								</td>
								<td class="al_center">
									<a href="javascript:void(0)" @click="purchaseGo(item.po_no)">{{ item.po_dn }} </a>
								</td>
								<td class="al_left">{{ item.vendor_code }}</td>
								<td class="al_left truncate">{{ item.vendor_name }}</td>
								<td class="al_left">{{ item.class_code }}</td>
								<td class="al_left">{{ item.class_name }}</td>
								<td v-if="user.company_id != 'jc'" class="al_left">{{ item.color_code }}</td>
								<td class="al_right">{{ item.received_quantity | commaSeparated }}</td>
								<td class="al_right">{{ item.unit_price | toCurrency }}</td>
								<td class="al_right">{{ item.received_amount | toCurrency }}</td>
							</tr>
						</tbody>
					</table>
				</div>
			</div>
		</div>
		<div style="text-align:right;padding-right:10px;">Total Count : {{ root.value.length | commaSeparated }}</div>
		<div class="bottom_bt_box">
			<ul>
				<li>
					<a href="javascript:void(0);" v-on:click="excel">Excel</a>
				</li>
			</ul>
		</div>
	</div>
</template>

<script>
import { daysAgo, today, toDate } from '@/utils/date';
import CustomDatePicker from '@/components/common/CustomDatePicker.vue';
import PartnerSelect from '@/components/common/PartnerSelect';
import { shipmentPageGo, purchasePageGo, exportDataExcel, objectCopy } from '@/api/util';
import { apiReceivedGoods } from '@/api/purchase/purchase';
import { defaultDataType } from 'export-xlsx';
import ItemClassSelectMultiS from '@/components/common/ItemClassSelectMultiS';

export default {
	data: function() {
		return {
			fromDate: daysAgo(6),
			toDate: today(),
			vendorCode: null,
			itemClasses: [],
			root: {
				value: {
					list: [],
				},
			},
		};
	},
	computed: {
		headers: function() {
			return { class: this.$session.get('headerClass') };
		},
		user: function() {
			return this.$session.get('user');
		},
	},
	components: {
		CustomDatePicker,
		PartnerSelect,
		ItemClassSelectMultiS,
	},
	methods: {
		setPartner(partner) {
			this.vendor_code = partner.code;
			this.search();
		},
		reset() {
			this.fromDate = daysAgo(6);
			this.toDate = today();
			this.vendor_code = null;
			this.$refs.ItemClassSelectMultiS.reset();
		},
		async search() {
			const paramObj = {
				from_date: this.fromDate,
				to_date: this.toDate,
				vendor_code: this.vendorCode,
				item_classes: this.itemClasses,
			};
			//const param = objectToFormData(paramObj);
			var { data } = await apiReceivedGoods(paramObj);
			//console.log(data);

			if (!this.user.po_price_view) {
				data.value.forEach(l => {
					l.unit_price = null;
					l.received_amount = null;
					l.vendor_code = null;
					l.vendor_name = null;
				});
			}

			this.root = data;
		},
		excel() {
			const result_list = objectCopy(this.root.value);
			const fileName = 'ReceivedGoods_' + this.fromDate + '_' + this.toDate;
			const headers = [
				{ key: 'received_date', name: 'Received Date', width: 15, dataType: defaultDataType.date },
				{ key: 'sh_dn', name: 'SH No.', width: 15, dataType: defaultDataType.string },
				{ key: 'vendor_code', name: 'Vendor Code', width: 15, dataType: defaultDataType.string },
				{ key: 'vendor_name', name: 'Vendor Name', width: 30, dataType: defaultDataType.string },
				{ key: 'class_code', name: 'Class Code', width: 15, dataType: defaultDataType.string },
				{ key: 'class_name', name: 'Item', width: 45, dataType: defaultDataType.string },
				{ key: 'color_code', name: 'Color', width: 15, dataType: defaultDataType.string },
				{ key: 'received_quantity', name: 'Qty', width: 15, dataType: defaultDataType.currency },
				{ key: 'unit_price', name: 'Price', width: 15, dataType: defaultDataType.number },
				{ key: 'received_amount', name: 'Amount', width: 15, dataType: defaultDataType.number },
			];

			result_list.forEach(el => (el.received_date = toDate(el.received_date)));
			exportDataExcel(result_list, headers, fileName);
		},
		shipmentGo(shipmentNo) {
			shipmentPageGo(shipmentNo);
		},
		purchaseGo(po_no) {
			purchasePageGo(po_no);
		},
	},
	created() {
		this.$store.commit('setSideIndex', 2);
		this.$store.commit('setSelectedMenu', 'nav_li_receivedGoods');
		this.$store.commit('setSubTitle', 'Purchase -> Received Goods');
	},
	mounted() {},
};
</script>

<style></style>
